import {Drawer} from 'components/customer/Preview3D/types';
import {Product} from 'components/customer/Product/entity/Product';
import {getQFPFaceHeights} from 'components/customer/QFPRedux/helpers/getQFPFaceHeights';

interface DrawerValues {
    drawers?: Drawer[];
    drawer_face_height?: number[];
    [key: string]: unknown;
}

export const toDrawers = (heights: number[]): Drawer[] =>
    heights
        .filter((h) => h !== -1)
        .map((h) => ({
            drawer_face_height: h,
            drawer_runner_specs: '',
            drawer_style: 0,
            drawer_type: 0,
        }));

export const normalizeDrawerValues = (values: DrawerValues): DrawerValues => {
    if (values.drawer_face_height?.length) {
        const existingHeights =
            values.drawers?.map((d) => d.drawer_face_height) ?? [];
        const newHeights = values.drawer_face_height;

        const heightsChanged =
            existingHeights.length !== newHeights.length ||
            newHeights.some(
                (h, i) => String(h) !== String(existingHeights.at(i))
            );

        if (!values.drawers?.length || heightsChanged) {
            values.drawers = toDrawers(values.drawer_face_height);
        }
    }

    return values;
};

export const normalizeProductWithDrawers = (
    product: Product,
    forceUpdate = false
): Product => {
    if (!forceUpdate && product.drawers?.length) return product;

    const drawers = toDrawers(product?.drawer_face_height ?? []);
    return {
        ...product,
        drawer_amount: Number(product.drawer_amount) || drawers.length,
        drawers,
    };
};

export const normalizeProductDrawers = (
    product: Product,
    forceUpdate = false
): Product => {
    const heights =
        product.drawer_face_heights?.split(',').map((h) => Number(h.trim())) ??
        [];
    const {faceHeightValues: updatedFaceHeights} = getQFPFaceHeights(
        product.drawer_amount ?? 0,
        product.cabinet_height ?? 0,
        product.drawer_gap ?? 0,
        product.drawer_gap ?? 0,
        [],
        heights
    );
    return normalizeProductWithDrawers(
        {
            ...product,
            drawer_face_height: updatedFaceHeights,
        },
        forceUpdate
    );
};
